import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "modal-right" }
const _hoisted_2 = { class: "modal-body scroll-wrapper" }
const _hoisted_3 = { class: "house-info-card" }
const _hoisted_4 = { class: "modal-footer" }
const _hoisted_5 = { class: "footer-content" }
const _hoisted_6 = { class: "subtotal" }
const _hoisted_7 = { class: "subtotal-amount" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $props.isOpen,
    onClose: $setup.onClose,
    transitionName: 'modal-slide',
    classes: ['select-builder-quotes-lists-modal']
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "modal-header scroll-wrapper" }, [
          _createElementVNode("div", { class: "modal-title" }, "Quote Summary"),
          _createElementVNode("div", { class: "line" })
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.allSummaryItems, (item) => {
              return (_openBlock(), _createBlock($setup["BuilderEstimatorQuoterSummaryItem"], {
                key: item.id || item.title,
                title: item.title,
                value: item.value,
                price: item.price,
                imageUrl: item.imageUrl,
                isFloorplan: item?.isFloorplan
              }, null, 8, ["title", "value", "price", "imageUrl", "isFloorplan"]))
            }), 128))
          ])
        ]),
        _createElementVNode("footer", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[0] || (_cache[0] = _createElementVNode("span", { class: "subtotal-label" }, "SUBTOTAL:", -1)),
              _createElementVNode("span", _hoisted_7, _toDisplayString($props.totalPrice), 1)
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["isOpen"]))
}